import React from 'react'
import QRCode from 'react-qr-code'
import { useParams } from 'react-router-dom';
import { useTenant } from '../../hooks';
import { useTranslation } from 'react-i18next';

const QrPrintableService = ({ item, printableRef }) => {
    const [t] = useTranslation('global')
    const params = useParams();
    const _qrValue = `${process.env.REACT_APP_RATING_WEB_USER_BASE_URL}/${params.tenant}/${item._id}` ;
    const {currentCompany} = useTenant();
    const companyName = currentCompany?.name?.find((name) => name?.lang === 'ar')?.text
        || currentCompany?.name?.find((name) => name?.lang === 'en')?.text
        || currentCompany?.name?.[0]?.text
        || '';
    
    const _Powerdby = `${process.env.REACT_APP_POWERD_BY_URL}` ;

    return (
        <div id={`printablediv-${item._id}`} ref={printableRef} className='hidden flex flex-col justify-between    ' >
                <div className='flex justify-between gap-12 '>
                    <div className='flex-1 text-start'>
                        {currentCompany?.logo && (
                            <img
                                src={currentCompany.logo}
                                alt=""
                                className='w-fit max-w-48 '
                                onError={(event) => {
                                    event.currentTarget.style.display = 'none';
                                }}
                            />
                        )}
                    </div>
                    <div className='flex-1 pt-10'>
                        <div className='text-end  text-2xl font-bold '>{t('qr.titleAr')}</div>
                        <div className='text-end  text-lg font-bold '>{t('qr.titleEn')}</div>
                    </div>
                </div>
                <div className='flex-1 p-5  '>
                    <div className='w-full pt-5 flex flex-col justify-center items-center '>
                        {companyName && (
                            <div className='text-center px-8 pb-2 text-4xl font-bold'>{companyName}</div>
                        )}
                        <div className='text-center p-8 text-3xl font-bold'>{item.serviceName}</div>
                        <div className='w-full flex flex-col justify-center items-center  rounded bg-slate-100'>
                            <div className='w-5/6  flex justify-between items-between   px-2  font-bold '>
                                <span className='flex-1'>{t('qr.scanEn')}</span>
                                <span className='flex-1 text-end'>{t('qr.scanAr')}</span>
                            </div>
                            <QRCode
                                className='w-75'
                                size={128}
                                style={{ height: "auto", maxWidth: "80%", width: "80%"  }}
                                value={_qrValue}
                                viewBox={`0 0 128`}
                                />
                            <div className='p-1 flex justify-between  '>
                                <span>{ _Powerdby }</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default QrPrintableService
